<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="lang.polaris.training.rating_scales" :actions="card_actions" :bus="bus">
            <trax-training-rating-crud-table :bus="bus" :id="id" 
                :endpoint="endpoint">
            </trax-training-rating-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-training-rating-crud-form :bus="bus" :id="id+'-edit'" :toastr-id="id+'-toastr'"
                :endpoint="endpoint">
            </trax-training-rating-crud-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.training.rating_scale_deletion" :bus="bus">
            {{ lang.polaris.training.confirm_delete_rating_scale_q }}
        </trax-ui-modal-confirm>
            
        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <trax-training-rating-crud-search :id="id" :bus="bus"></trax-training-rating-crud-search>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-rating'},
        },
    
        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url+"polaris/api/front/rating-scales",
                card_actions: [
                    { icon: 'search', event: this.id+'-search-open' },
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        }
    }
</script>
